/**
 * Queue pocket deal HTML emails (Cloud Function sends via Resend + Rentalyzer template).
 */
import { collection, addDoc } from 'firebase/firestore';
import { firestore } from '../config/firebase';

const COLLECTION = 'pocketDealEmails';

/**
 * @param {object} payload
 * @param {string} payload.brokerUid
 * @param {string} payload.to
 * @param {string} payload.shareToken
 * @param {string} payload.shareUrl
 * @param {string} payload.clientId
 * @param {string} [payload.campaignId]
 * @param {string} [payload.senderDisplayName]
 * @param {string} [payload.subjectLine]
 * @param {string} [payload.preheader]
 * @param {string} [payload.introText]
 * @param {boolean} [payload.includeDescription]
 * @param {boolean} [payload.includeImage]
 * @param {boolean} [payload.includeMetrics]
 * @param {boolean} [payload.includeScenario]
 * @param {string|null} [payload.scenarioId]
 * @param {string} [payload.locale] fr | en (legacy; prefer emailLanguages)
 * @param {'fr'|'en'|'both'} [payload.emailLanguages]
 */
export async function queuePocketDealEmail(payload) {
  const {
    brokerUid,
    to,
    shareToken,
    shareUrl,
    clientId,
    campaignId = null,
    senderDisplayName = '',
    subjectLine = '',
    preheader = '',
    introText = '',
    includeDescription = false,
    includeImage = false,
    includeMetrics = false,
    includeScenario = false,
    scenarioId = null,
    locale = 'fr',
    emailLanguages: emailLanguagesRaw = null,
  } = payload;
  if (!brokerUid || !to || !shareToken || !shareUrl || !clientId) {
    throw new Error('brokerUid, to, shareToken, shareUrl, clientId required');
  }
  const ref = collection(firestore, COLLECTION);
  await addDoc(ref, {
    brokerUid,
    to: String(to).trim().toLowerCase(),
    shareToken,
    shareUrl: String(shareUrl),
    /** Toujours string pour matcher Firestore + Cloud Function (évite mismatch strict !==) */
    clientId: String(clientId),
    campaignId,
    senderDisplayName: String(senderDisplayName || '').trim(),
    subjectLine: String(subjectLine || '').trim(),
    preheader: String(preheader || '').trim(),
    introText: String(introText || '').trim(),
    includeDescription: !!includeDescription,
    includeImage: !!includeImage,
    includeMetrics: !!includeMetrics,
    includeScenario: !!includeScenario,
    scenarioId: scenarioId || null,
    locale: locale === 'en' ? 'en' : 'fr',
    emailLanguages:
      emailLanguagesRaw === 'fr' || emailLanguagesRaw === 'en' || emailLanguagesRaw === 'both'
        ? emailLanguagesRaw
        : locale === 'en'
          ? 'en'
          : 'fr',
    status: 'pending',
    createdAt: new Date(),
  });
}
